import { Summary, Tag } from 'src/services/tag/Tag';
import { currentMonth } from 'src/utils/currentMonth';

export const offlineTags: Tag[] = [
  {
    fullPath: 'accounts',
    color: 'blue',
    id: 'uuid-612312',
    isArchived: false,
    summary: Summary.runningBalance,
  },
  {
    fullPath: 'accounts/revolut',
    color: 'blue',
    id: 'uuid-6',
    isArchived: false,
    summary: Summary.runningBalance,
  },
  {
    fullPath: 'accounts/bank-account',
    color: 'blue',
    isArchived: false,
    summary: Summary.runningBalance,
    id: 'uuid-7',
  },
  {
    fullPath: 'accounts/cash',
    color: 'blue',
    isArchived: false,
    summary: Summary.runningBalance,
    id: 'uuid-8',
  },
  {
    fullPath: `${new Date().getFullYear() - 1}-greece`,
    color: 'orange',
    isArchived: false,
    summary: Summary.expenditureProgress,
    id: 'uuid-9898',
    plannedExpenditure: 1000,
  },

  {
    fullPath: 'family',
    color: 'green',
    id: 'uuid-1',
    isArchived: false,
    summary: Summary.expenditureProgress,
    plannedExpenditure: 1160, // ~417000 HUF
    isPeriodic: true,
    periods: [
      {
        period: {
          year: currentMonth(1).getFullYear(),
          month: currentMonth(1).getMonth() + 1,
        },
        plannedExpenditure: 930, // ~335000 HUF
      },
      {
        period: {
          year: currentMonth(1, -1).getFullYear(),
          month: currentMonth(1, -1).getMonth() + 1,
        },
        plannedExpenditure: 890, // ~320000 HUF
      },
      {
        period: {
          year: currentMonth(1, -2).getFullYear(),
          month: currentMonth(1, -2).getMonth() + 1,
        },
        plannedExpenditure: 875, // ~315000 HUF
      },
    ],
  },
  {
    fullPath: 'family/groceries',
    color: 'green',
    isArchived: false,
    id: 'uuid-2',
    plannedExpenditure: 335, // ~120000 HUF
    isPeriodic: true,
    periods: [
      {
        period: {
          year: currentMonth(1).getFullYear(),
          month: currentMonth(1).getMonth() + 1,
        },
        plannedExpenditure: 250, // ~90000 HUF
      },
      {
        period: {
          year: currentMonth(1, -1).getFullYear(),
          month: currentMonth(1, -1).getMonth() + 1,
        },
        plannedExpenditure: 3050, // ~1100000 HUF
      },
      {
        period: {
          year: currentMonth(1, -2).getFullYear(),
          month: currentMonth(1, -2).getMonth() + 1,
        },
        plannedExpenditure: 2920, // ~1050000 HUF
      },
    ],
  },
  {
    fullPath: 'family/utilities',
    color: 'green',
    isArchived: false,
    id: 'uuid-3',
    plannedExpenditure: 45, // ~16000 HUF
    isPeriodic: true,
    periods: [
      {
        period: {
          year: currentMonth(1).getFullYear(),
          month: currentMonth(1).getMonth() + 1,
        },
        plannedExpenditure: 85, // ~30000 HUF
      },
      {
        period: {
          year: currentMonth(1, -1).getFullYear(),
          month: currentMonth(1, -1).getMonth() + 1,
        },
        plannedExpenditure: 140, // ~50000 HUF
      },
      {
        period: {
          year: currentMonth(1, -2).getFullYear(),
          month: currentMonth(1, -2).getMonth() + 1,
        },
        plannedExpenditure: 125, // ~45000 HUF
      },
    ],
  },
  {
    fullPath: 'family/mortgage',
    color: 'green',
    isArchived: false,
    id: 'uuid-18',
    plannedExpenditure: 305, // ~110000 HUF
    isPeriodic: true,
    periods: [
      {
        period: {
          year: currentMonth(1).getFullYear(),
          month: currentMonth(1).getMonth() + 1,
        },
        plannedExpenditure: 305, // ~110000 HUF
      },
      {
        period: {
          year: currentMonth(1, -1).getFullYear(),
          month: currentMonth(1, -1).getMonth() + 1,
        },
        plannedExpenditure: 360, // ~130000 HUF
      },
      {
        period: {
          year: currentMonth(1, -2).getFullYear(),
          month: currentMonth(1, -2).getMonth() + 1,
        },
        plannedExpenditure: 350, // ~125000 HUF
      },
    ],
  },
  {
    fullPath: 'family/fast-food',
    color: 'green',
    isArchived: false,
    plannedExpenditure: 55, // ~20000 HUF
    id: 'uuid-5',
    isPeriodic: true,
    periods: [
      {
        period: {
          year: currentMonth(1).getFullYear(),
          month: currentMonth(1).getMonth() + 1,
        },
        plannedExpenditure: 28, // ~10000 HUF
      },
      {
        period: {
          year: currentMonth(1, -1).getFullYear(),
          month: currentMonth(1, -1).getMonth() + 1,
        },
        plannedExpenditure: 14, // ~5000 HUF
      },
      {
        period: {
          year: currentMonth(1, -2).getFullYear(),
          month: currentMonth(1, -2).getMonth() + 1,
        },
        plannedExpenditure: 28, // ~10000 HUF
      },
    ],
  },
  {
    fullPath: 'family/fun',
    color: 'green',
    isArchived: false,
    plannedExpenditure: 125, // ~45000 HUF
    id: 'uuid-10',
    isPeriodic: true,
    periods: [
      {
        period: {
          year: currentMonth(1).getFullYear(),
          month: currentMonth(1).getMonth() + 1,
        },
        plannedExpenditure: 140, // ~50000 HUF
      },
      {
        period: {
          year: currentMonth(1, -1).getFullYear(),
          month: currentMonth(1, -1).getMonth() + 1,
        },
        plannedExpenditure: 195, // ~70000 HUF
      },
      {
        period: {
          year: currentMonth(1, -2).getFullYear(),
          month: currentMonth(1, -2).getMonth() + 1,
        },
        plannedExpenditure: 85, // ~30000 HUF
      },
    ],
  },
  {
    fullPath: 'family/commuting',
    color: 'green',
    isArchived: false,
    plannedExpenditure: 110, // ~40000 HUF
    id: 'uuid-11',
    isPeriodic: true,
    periods: [
      {
        period: {
          year: currentMonth(1).getFullYear(),
          month: currentMonth(1).getMonth() + 1,
        },
        plannedExpenditure: 125, // ~45000 HUF
      },
      {
        period: {
          year: currentMonth(1, -1).getFullYear(),
          month: currentMonth(1, -1).getMonth() + 1,
        },
        plannedExpenditure: 110, // ~40000 HUF
      },
      {
        period: {
          year: currentMonth(1, -2).getFullYear(),
          month: currentMonth(1, -2).getMonth() + 1,
        },
        plannedExpenditure: 110, // ~40000 HUF
      },
    ],
  },
  {
    fullPath: 'arrange',
    color: 'red',
    isArchived: false,
    summary: Summary.none,
    id: 'uuid-9',
  },
];
